import { useTranslations } from 'next-intl'

import { Form } from '@/shared/ui'

export const TaxInvoiceFields = () => {
  const t = useTranslations('receipt_information.issue_request')

  return (
    <div className="space-y-3">
      <Form.Field name="corpId">
        <Form.Label bold>{t('business_number.label')}</Form.Label>
        <Form.TextField
          type="number"
          placeholder={t('business_number.placeholder')}
          fullWidth
        />
        <Form.Message />
      </Form.Field>

      <Form.Field name="corpName">
        <Form.Label bold>{t('business_name.label')}</Form.Label>
        <Form.TextField
          type="text"
          placeholder={t('business_name.placeholder')}
          fullWidth
        />
        <Form.Message />
      </Form.Field>

      <Form.Field name="corpCeo">
        <Form.Label bold>{t('representative_name.label')}</Form.Label>
        <Form.TextField
          type="text"
          placeholder={t('representative_name.placeholder')}
          fullWidth
        />
        <Form.Message />
      </Form.Field>

      <Form.Field name="invoiceeEmail" className="grow">
        <Form.Label bold>{t('email.label')}</Form.Label>
        <Form.TextField
          type="email"
          placeholder={t('email.placeholder')}
          fullWidth
        />
        <Form.Message />
      </Form.Field>
    </div>
  )
}
